var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn",domProps:{"innerHTML":_vm._s(_vm.$t('Webportal.Imprint.ContentVue2'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }